function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
var _ref = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M38.38 44.5H16.16v-9.37h-3v9.37H9.62V32.51h-3V46c0 .83.67 1.5 1.5 1.5h31.77c.83 0 1.5-.67 1.5-1.5V32.51h-3V44.5zm.82-23.27H28.38V4.88C28.38 2.46 26.42.5 24 .5s-4.38 1.96-4.38 4.38v16.34H8.8c-3.12 0-5.66 2.54-5.66 5.66V29c0 .83.67 1.5 1.5 1.5h38.73c.83 0 1.5-.67 1.5-1.5v-2.12c0-3.11-2.54-5.65-5.67-5.65z"
});
var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 48 48"
  }, props), _ref);
};
export default __webpack_public_path__ + "static/media/paint.83fba361.svg";
export { SvgComponent as ReactComponent };